import { addGlobalNotificationEAuthz } from "../../app/services/GlobalNotification/addGlobalNotificationEAuthz"
import { getAllGlobalNotificationEAuthz } from "../../app/services/GlobalNotification/getAllGlobalNotificationEAuthz"
import { getAllNotificationTypesEAuthz } from "../../app/services/GlobalNotification/getAllNotificationTypesEAuthz"
import { updateGlobalNotificationEAuthz } from "../../app/services/GlobalNotification/updateGlobalNotificationEAuthz"
import { globalNotificationTypes } from "../constants/action-types"
import { setErrorTextSnackBar, setRequestTextSnackBar } from "./app"

const setErrorTypes = (error) => {
  return {
    type: globalNotificationTypes.TYPES_FAILURE,
    payload: error,
  }
}
const setSuccessTypes = (data) => {
  return {
    type: globalNotificationTypes.TYPES_SUCCESS,
    payload: data,
  }
}
export const setRequestTypes = () => {
  return {
    type: globalNotificationTypes.TYPES_REQUEST,
  }
}

export const getAllGlobalNotification = (appCodes) => {
  return async (dispatch) => {
    try {
      const response = await getAllGlobalNotificationEAuthz(appCodes)
      return response.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: Global Notification",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return null
    }
  }
}

export const getAllNotificationTypes = () => {
  return async (dispatch) => {
    try {
      const response = await getAllNotificationTypesEAuthz()
      dispatch(setSuccessTypes(response.data?.data))
    } catch (error) {
      dispatch(setErrorTypes())
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
    }
  }
}
export const addGlobalNotification = (body) => {
  return async (dispatch) => {
    try {
      const response = await addGlobalNotificationEAuthz(body)
      return response.data?.data
    } catch (error) {
      return null
    }
  }
}

export const updateGlobalNotification = (body) => {
  return async (dispatch) => {
    try {
      const response = await updateGlobalNotificationEAuthz(body)
      return response?.data?.data
    } catch (error) {
      if (error.response?.status === 404) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: Global Notification",
          ),
        )
      }
      if (error.response?.data?.codeMessageLanguage) {
        dispatch(setRequestTextSnackBar())
        dispatch(
          setErrorTextSnackBar(
            "Ocurrió un error en un servicio de: " +
              error.response?.data?.codeMessageLanguage,
          ),
        )
      }
      return null
    }
  }
}
